import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import RoleInput from '@/components/Common/RoleInput'
import StyledBgContainer from '@/components/StyledBgContainer/StyledBgContainer'
import StyledButton from '@/components/Button/Button'
import TopNav from '@/components/TopNav/TopNav'
import useLocalStorage from '@/hooks/useLocalStorage'
import { AdminRole } from '@/utils/config/auth-enums'
import Path from '@/router/localRoutes'
import './Role.css'

const Role = () => {
  const [role, setRole] = useState<AdminRole | undefined>()
  const navigate = useNavigate()
  const onSelectRole = (value: AdminRole) => {
    setRole(value)
  }
  const [, setRoleName] = useLocalStorage('role')

  const handleContinue = () => {
    setRoleName(role ?? null)
    navigate(Path.Signin)
  }

  return (
    <StyledBgContainer>
      <div className="role-container">
        <Grid container>
          <Grid item xs={12}>
            <TopNav />
          </Grid>
          <Grid item xs={12}>
            <h1 className="role-heading mb-3 font-bold">Select Your Role</h1>
          </Grid>

          <p className="text-center mb-6 mx-auto font-semibold text-[#848484]">
            Please select your role
          </p>

          <Grid item xs={12}>
            <RoleInput
              type="button"
              selected={role === AdminRole.GLOBAL_ADMIN}
              value="Global Admin"
              onClick={() => onSelectRole(AdminRole.GLOBAL_ADMIN)}
            />
          </Grid>
          <Grid item xs={12}>
            <RoleInput
              type="button"
              selected={role === AdminRole.SUB_ADMIN}
              value="Sub - Admin"
              onClick={() => onSelectRole(AdminRole.SUB_ADMIN)}
            />
          </Grid>
          <div className="absolute bottom-12 left-0 right-0 mb-8 flex flex-col items-center">
            <StyledButton
              className="!shadow-2xl !font-sans w-[120px] !h-[45px] !text-[14px]"
              disabled={!role}
              onClick={handleContinue}
            >
              Continue
            </StyledButton>
          </div>
        </Grid>
      </div>
    </StyledBgContainer>
  )
}

export default Role
